import { Popover as BasicPopover } from '@bedrock/components';
import './index.less';

export default BasicPopover;
